import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-748c9ccb")

_pushScopeId("data-v-748c9ccb")
const _hoisted_1 = { class: "input-file" }
const _hoisted_2 = { class: "container-input" }
const _hoisted_3 = { class: "container-text" }
const _hoisted_4 = { class: "text-input-file" }
const _hoisted_5 = {
  class: "text-downloaded",
  for: "downloaded",
  tabindex: "0"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("input", {
  class: "input",
  type: "file",
  name: "file",
  id: "downloaded",
  multiple: ""
}, null, -1)
const _hoisted_7 = { class: "text-max-size" }
const _hoisted_8 = {
  key: 0,
  class: "wrap-downloaded-files"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")
  const _component_DownloadedFiles = _resolveComponent("DownloadedFiles")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h3", null, _toDisplayString(_ctx.t('fileInput.title')), 1),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Icon, {
          class: "icon-download",
          spriteUrl: "/image/videoconf-icons.svg",
          name: "ic25-download"
        }),
        _createVNode("p", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.t('fileInput.input')), 1),
          _createVNode("label", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.t('fileInput.browse')), 1),
            _hoisted_6
          ])
        ])
      ]),
      _createVNode("p", _hoisted_7, _toDisplayString(_ctx.t('fileInput.maxSize')), 1)
    ]),
    (_ctx.isDefault)
      ? (_openBlock(), _createBlock("div", _hoisted_8, [
          false
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "text-delete-all",
                size: "s",
                mode: "flat"
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('fileInput.delete')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_DownloadedFiles),
          _createVNode(_component_DownloadedFiles)
        ]))
      : _createCommentVNode("", true)
  ]))
})